import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const LocationList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;

  ${props =>
    props.center &&
    `
    justify-content: center;
    padding: 50px 0;
  `}
`;

const LocationTagContainer = styled.div`
  display: flex;
  margin: 10px;
  border: 1px solid ${props => props.theme.colors.primary};
  justify-content: space-between;
  border-radius: 8px;
  overflow: hidden;
`;

const LocationTagText = styled.div`
  padding: 10px;
  font-size: 14px;
`;

const LocationIcon = styled.div`
  border-left: 1px solid ${props => props.theme.colors.primary};
  cursor: pointer;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.25s;

  &:hover {
    background: ${props => props.theme.colors.primary};
    transition: 0.25s;
    svg {
      color: #fff;
    }
  }

  svg {
    color: ${props => props.theme.colors.primary};
    font-size: 20px;
  }
`;

const Actions = styled.div`
  display: grid;
  grid-template-columns: 1fr 200px;
  grid-gap: 20px;

  button {
    margin-top: 40px;
  }

  ${props => props.theme.media.phone`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  
    .input-container {
      width: 100%;
    }

    button {
      margin: 0;
      width: 100%;
      margin-top: 20px;
    }
  `}
`;

export { Form, LocationList, LocationTagContainer, LocationTagText, LocationIcon, Actions };
